import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@/core/services/open-api/user.service';
@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    // styleUrls: ['./help.component.scss'],
    standalone: false,
})
export class HelpComponent implements OnInit {
    constructor(
        private readonly translate: TranslateService,
        public userService: UserService,
    ) {}

    ngOnInit(): void {
        // Empty
    }

    linkToSupport(): void {
        this.translate.get(['language_parameter_store_link']).subscribe((translations) => {
            this.userService.getLicensesURL().subscribe((data) => {
                const domain = data.split('?');
                const newUrl = domain[0] + translations.language_parameter_store_link + '/support' + '?' + domain[1];
                window.open(newUrl, '_self', 'noopener');
            });
        });
    }

    openTutorial(): void {
        window.open('https://www.youtube.com/c/Timebuzzer/', '_blank', 'noopener');
    }

    openDoc(): void {
        this.translate.get('help_documentation_link').subscribe((url) => {
            window.open(url, '_blank', 'noopener');
        });
    }

    openHelp(): void {
        window.open('https://timebuzzer.com/pricing/#faq', '_blank', 'noopener');
    }
}
